import { Component, Input } from '@angular/core';

@Component({
    selector: 'group-summary',
    styles: [`
        .back-link {
            padding-bottom: 12px;
        }

        .trim-container {
           min-width: 0px;
        }
        
        .image-row {
            min-height: 88px;
        }

        .description {
            padding-bottom: 10px;
            height: 49px; 
            overflow: hidden;
        }
        
        .user-count {
            padding-left: 5px; 
            padding-right: 8px;
        }
        
        .item-count {
            padding-left: 15px;
            padding-right: 8px;
        }
        
        .count-wrapper {
            display: inline-block;
            padding-right: 15px;
        }

        .count {
            font-align: center;
        }

        h4 {
            margin-top: 0px;
            margin-bottom: 0px;
        }
    `],
    template: `
        <mat-card>
            <mat-card-content>
                <div fxFlex="100" fxFlexFill fxLayout="row" class="image-row">
                    <div style="padding-right:25px;">
                        <a style="text-decoration: none" [routerLink]="['../', group.id]"><group-avatar [group]="group"></group-avatar></a>    
                    </div>
                    <div fxFlex fxLayout="column" class="trim-container">
                        <mat-card-title fxFlex [matTooltip]="group.name">
                            <div style="overflow: hidden; white-space: nowrap;">
                                <a style="text-decoration: none" [routerLink]="['../', group.id]"><h4 style="text-overflow: ellipsis; overflow: hidden;">{{group.name}}</h4></a>
                            </div>
                        </mat-card-title>
                        <div>
                            <div fxFlex class="description">{{group.description}}</div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions style="padding-top: 0px;">
                <group-members-indicator [group]="group"></group-members-indicator>
                <button mat-button matTooltip="Invite to {{group.name}}" [routerLink]="['../', group.id, 'invite']"><mat-icon>person_add</mat-icon></button>
                <span fxFlex></span>
                <group-membership-button [group]="group"></group-membership-button>
            </mat-card-actions>
        </mat-card>
    `})
export class GroupSummaryComponent {
    @Input() group: any;
}
